import { parsePhoneNumberFromString } from 'libphonenumber-js';
function normalizeInternationalNumber(countryCode, nationalNumber) {
    const normalizedCountryCode = countryCode.trim();
    const normalizedNationalNumber = nationalNumber.trim();
    return `${normalizedCountryCode}${normalizedNationalNumber}`;
}
export function isValidCountryCode(countryCode) {
    const normalizedCountryCode = countryCode.trim();
    if (!normalizedCountryCode.startsWith('+')) {
        return false;
    }
    // Validate the calling code through parsing rather than regex-only checks.
    const parsed = parsePhoneNumberFromString(`${normalizedCountryCode}111111`);
    return Boolean(parsed && `+${parsed.countryCallingCode}` === normalizedCountryCode);
}
export function isValidInternationalPhoneNumber(countryCode, nationalNumber) {
    const parsed = parsePhoneNumberFromString(normalizeInternationalNumber(countryCode, nationalNumber));
    return Boolean(parsed?.isValid() && `+${parsed.countryCallingCode}` === countryCode.trim());
}
/**
 * Formats a (countryCode, nationalNumber) pair as an E.164 string, e.g. "+821012345678".
 * Returns null if the input can't be parsed to a valid number — the caller must decide
 * whether to refuse the submission or send the raw value. The backend expects E.164.
 */
export function toE164(countryCode, nationalNumber) {
    const parsed = parsePhoneNumberFromString(normalizeInternationalNumber(countryCode, nationalNumber));
    if (!parsed || !parsed.isValid())
        return null;
    if (`+${parsed.countryCallingCode}` !== countryCode.trim())
        return null;
    return parsed.format('E.164');
}
/**
 * Inverse of `toE164`: splits an E.164 string back into a `(countryCode, nationalNumber)`
 * pair so we can pre-fill the country-code dropdown + national-number input. Returns null
 * when the input is empty or unparseable.
 */
export function splitE164(e164) {
    const trimmed = (e164 || '').trim();
    if (!trimmed)
        return null;
    const parsed = parsePhoneNumberFromString(trimmed);
    if (!parsed)
        return null;
    return {
        countryCode: `+${parsed.countryCallingCode}`,
        nationalNumber: parsed.nationalNumber,
    };
}
